import React, { useState, useEffect } from "react";
import Base from "../admin_components/Admin_Base";
import "../Invoices_Payments/Paymentgateway.css";
import { ADMIN_API_BASE_URL } from "../Auth/Api";
import authAxios from "../Auth/useAxios";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Breadcrumbs } from "@mui/material";
import { Link } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button } from "@mui/material";

const PaymentsReceivedWhenGatewayisDown = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [openDialog, setOpenDialog] = useState(false);
  const [currentPaymentId, setCurrentPaymentId] = useState(null);
  const [currentApprovalStatus, setCurrentApprovalStatus] = useState(false);
  const [amount, setAmount] = useState("");
  const itemsPerPage = 15;

  const fetchManualPayments = async () => {
    try {
      const response = await authAxios.get(`${ADMIN_API_BASE_URL}/main/admin/get-all-manual-payments`);
      setTransactions(response.data);
    } catch (err) {
      setError(err.message);
      console.error('Error fetching manual payments:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchManualPayments();
  }, []);

  const handleStatusUpdate = async (id, isApproved, transaction) => {
    // Check if emiMonth and emiYear are blank
    if (!transaction.emiMonth || !transaction.emiYear) {
      setCurrentPaymentId(id);
      setCurrentApprovalStatus(isApproved);
      setOpenDialog(true);
    } else {
      try {
        const response = await authAxios.put(
          `${ADMIN_API_BASE_URL}/main/admin/approve-manual-payment/${id}?isApproved=${isApproved}`,
        );

        if (response.status !== 200) {
          throw new Error('Failed to update payment status');
        }

        setTransactions(prevTransactions =>
          prevTransactions.map(t =>
            t.id === id ? { ...t, status: isApproved } : t
          )
        );

        alert(`Payment ${isApproved ? 'approved' : 'rejected'} successfully`);
      } catch (err) {
        alert(`Error: ${err.message}`);
        console.error('Error updating payment status:', err);
      }
    }
  };

  const handleDialogSubmit = async () => {
    try {
      const response = await authAxios.put(
        `${ADMIN_API_BASE_URL}/main/admin/approve-thirty-percent-payment/${currentPaymentId}?isApproved=${currentApprovalStatus}&amount=${amount}`,
      );

      if (response.status !== 200) {
        throw new Error('Failed to update payment status');
      }

      setTransactions(prevTransactions =>
        prevTransactions.map(t =>
          t.id === currentPaymentId ? { ...t, status: currentApprovalStatus } : t
        )
      );

      alert(`Payment ${currentApprovalStatus ? 'approved' : 'rejected'} successfully`);
      setOpenDialog(false);
      setAmount("");
    } catch (err) {
      alert(`Error: ${err.message}`);
      console.error('Error updating payment status:', err);
    }
  };

  const handleApprove = (id, transaction) => {
    handleStatusUpdate(id, true, transaction);
  };

  const handleReject = (id, transaction) => {
    handleStatusUpdate(id, false, transaction);
  };

  const totalPages = Math.ceil(transactions.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedRequests = transactions.slice(startIndex, endIndex);

  return (
    <Base>
      {loading ? (
        <div style={{ display: "flex", justifyContent: "center", marginTop: "300px" }}>
          <ClipLoader color="darkslategrey" size={50} />
        </div>
      ) : error ? (
        <div>{error}</div>
      ) : (
        <>
          <div>
            <div className="pt-3 mt-5 mb-4" style={{ display: "flex", justifyContent: "flex-end", paddingRight: "20px" }}>
              <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
                <Link to="/admin/dashboard" style={{ color: "darkslategrey", fontWeight: "bold" }}>Dashboard</Link>
              </Breadcrumbs>
            </div>

            <p className="text-center fw-bold main_heading mb-1"> Payments Received When Gateway is Down</p>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <hr style={{ width: "90%" }} />
            </div>

            <div className="payment-table-container">
              <table className="payment-compact-table customer-table">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Customer Name</th>
                    <th>Property Name</th>
                    <th>Passbook Number</th>
                    <th>EMI Year</th>
                    <th>EMI Month</th>
                    <th>Payment description</th>
                    <th>Received Date</th>
                    <th>Attached Image</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedRequests.map((transaction, index) => (
                    <tr key={transaction.id}>
                      <td>{index + 1}</td>
                      <td>{transaction.customerName}</td>
                      <td>{transaction.propertyName}</td>
                      <td>{transaction.passbook}</td>
                      <td>{transaction.emiYear || '-'}</td>
                      <td>{transaction.emiMonth || '-'}</td>
                      <td>{transaction.payment}</td>
                      <td>{transaction.receivedDate}</td>
                      <td>
                        <img
                          src={transaction.screenshot}
                          alt="Payment receipt"
                          className="payment-attached-image"
                          style={{ width: '50px', height: "50px" }}
                          onClick={() => window.open(transaction.screenshot, '_blank')}
                        />
                      </td>
                      <td>
                        <span className={`status-${transaction.status}`}>
                          {transaction.status === true ? "Accepted" : "Not Accepted"}
                        </span>
                      </td>
                      <td style={{display:"flex"}}>
                        {transaction.status === false ? (
                          <>
                            <button
                              className="payment-action-button approve-button"
                              onClick={() => handleApprove(transaction.id, transaction)}
                            >
                              Approve
                            </button>
                            <button
                              className="payment-action-button reject-button"
                              onClick={() => handleReject(transaction.id, transaction)}
                              style={{ marginLeft: '8px' }}
                            >
                              Reject
                            </button>
                          </>
                        ) : (
                          <span className="payment-action-completed">
                            Action completed
                          </span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="pagination-controls-payment-history">
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
            >
              Previous
            </button>
            <span className="mx-2">
              Page {currentPage} of {totalPages}
            </span>
            <button
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
              disabled={currentPage === totalPages}
            >
              Next Page
            </button>
          </div>

          {/* Dialog for amount input */}
          <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
            <DialogTitle>Enter Payment Amount</DialogTitle>
            <DialogContent>
              <TextField
                autoFocus
                margin="dense"
                label="Amount"
                type="number"
                fullWidth
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
              <Button onClick={handleDialogSubmit}>Submit</Button>
            </DialogActions>
          </Dialog>
        </>
      )}
    </Base>
  );
};

export default PaymentsReceivedWhenGatewayisDown;